/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends, __values } from "tslib";
import { AnnotationLayer } from "./AnnotationLayer";
import { DependencyProperty } from "igniteui-react-core";
import { Base, runOn, delegateCombine, String_$type, enumGetBox, EnumUtil, typeCast, fromEnum, delegateRemove, Point_$type, Date_$type, markType, markDep } from "igniteui-react-core";
import { Series } from "./Series";
import { CalloutPlacementPositionsCollection } from "./CalloutPlacementPositionsCollection";
import { AutoCalloutVisibilityMode_$type } from "./AutoCalloutVisibilityMode";
import { Brush } from "igniteui-react-core";
import { Thickness } from "igniteui-react-core";
import { CalloutCollisionMode_$type } from "./CalloutCollisionMode";
import { FontUtil } from "igniteui-react-core";
import { Rect } from "igniteui-react-core";
import { CalloutLayerFrame } from "./CalloutLayerFrame";
import { HashSet$1 } from "igniteui-react-core";
import { CalloutAnnotationWrapper } from "./CalloutAnnotationWrapper";
import { List$1 } from "igniteui-react-core";
import { LinkedList$1 } from "igniteui-react-core";
import { Dictionary$2 } from "igniteui-react-core";
import { LinkedListNode$1 } from "igniteui-react-core";
import { LabelCollisionManager } from "igniteui-react-core";
import { SeriesPointOfInterest } from "./SeriesPointOfInterest";
import { CalloutAnnotation } from "./CalloutAnnotation";
import { IFastItemsSource_$type } from "igniteui-react-core";
import { CalloutLabelUpdatingEventArgs } from "./CalloutLabelUpdatingEventArgs";
import { CalloutSeriesSelectingEventArgs } from "./CalloutSeriesSelectingEventArgs";
import { CalloutStyleUpdatingEventArgs } from "./CalloutStyleUpdatingEventArgs";
import { DeviceUtils } from "igniteui-react-core";
import { CalloutRenderStyleUpdatingEventArgs } from "./CalloutRenderStyleUpdatingEventArgs";
import { LabelCollisionInfo } from "igniteui-react-core";
import { QuadTreeBoundingBox } from "igniteui-react-core";
import { ScalerParams } from "./ScalerParams";
import { ViewportUtils } from "./ViewportUtils";
import { Size } from "igniteui-react-core";
import { CalloutContentUpdatingEventArgs } from "./CalloutContentUpdatingEventArgs";
import { CalloutKey } from "./CalloutKey";
import { DataContext } from "igniteui-react-core";
import { HashPool$2 } from "igniteui-react-core";
import { PropertyMetadata } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
import { stringIsNullOrEmpty } from "igniteui-react-core";
import { FastItemObjectColumn } from "igniteui-react-core";
import { AnnotationLayerView } from "./AnnotationLayerView";
import { BrushUtil } from "igniteui-react-core";
import { TextBlock } from "igniteui-react-core";
import { Color } from "igniteui-react-core";
import { Line } from "igniteui-react-core";
import { CalloutViewHelper } from "./CalloutViewHelper";
import { Rectangle } from "igniteui-react-core";
import { TranslateTransform } from "igniteui-react-core";
/**
 * @hidden
 */
var CalloutLayer = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(CalloutLayer, _super);
    function CalloutLayer() {
        var _this = _super.call(this) || this;
        _this.calloutStyleUpdating = null;
        _this.calloutRenderStyleUpdating = null;
        _this.rw = null;
        _this.rx = null;
        _this.ry = null;
        _this.rv = null;
        _this.ru = null;
        _this.so = new HashSet$1(CalloutAnnotationWrapper.$, 0);
        _this.sr = new List$1(CalloutAnnotationWrapper.$, 0);
        _this.ss = new List$1(CalloutAnnotationWrapper.$, 0);
        _this.rm = null;
        _this.rc = null;
        _this.rs = null;
        _this.sp = new LinkedList$1(CalloutAnnotationWrapper.$);
        _this.sm = new Dictionary$2(CalloutAnnotationWrapper.$, LinkedListNode$1.$.specialize(CalloutAnnotationWrapper.$), 0);
        _this.r4 = null;
        _this.vy = new Rect(0, 0, 0, 1, 1);
        _this.sb = false;
        _this.s3 = 0;
        _this.vx = Rect.empty;
        _this.r9 = false;
        _this.sa = false;
        _this.calloutContentUpdating = null;
        _this.calloutLabelUpdating = null;
        _this.calloutSeriesSelecting = null;
        _this.sq = new List$1(SeriesPointOfInterest.$, 0);
        _this.sd = false;
        _this.se = false;
        _this.su = 0;
        _this.sc = false;
        _this.r8 = true;
        _this.re = 1;
        FastItemObjectColumn.m();
        _this.rc = null;
        _this.rm = new CalloutPlacementPositionsCollection();
        var a = _this.rm;
        a.collectionChanged = delegateCombine(a.collectionChanged, runOn(_this, _this.ui));
        _this.qi = true;
        var b = new CalloutLayerFrame();
        var c = new CalloutLayerFrame();
        var d = new CalloutLayerFrame();
        var e = _this.ho / 1000;
        _this.qa = b;
        _this.p9 = c;
        _this.qb = d;
        _this.ab = CalloutLayer.$;
        return _this;
    }
    CalloutLayer.prototype.get_c8 = function () {
        return true;
    };
    CalloutLayer.prototype.ui = function (a, b) {
        this.ur();
    };
    CalloutLayer.prototype.ur = function () {
        this.rc = this.rd(this.rn);
        this.uo();
    };
    CalloutLayer.prototype.uj = function (a, b) {
        this.ss.clear();
        this.ml(false);
    };
    CalloutLayer.prototype.k3 = function (a, b, c, d) {
        _super.prototype.k3.call(this, a, b, c, d);
        var e = this.sn();
        switch (a) {
            case 3:
                this.uw(b, e);
                break;
            case 1:
                for (var f = b; f < b + c; f++) {
                    var g = new CalloutAnnotation();
                    var h = new CalloutAnnotationWrapper();
                    h.b = g;
                    h.b.series = this.rr;
                    this.ss.insert(f, h);
                    this.uw(f, e);
                }
                break;
            case 0:
                this.ss.v(b, c);
                break;
            case 2:
                for (var i = b; i < b + c; i++) {
                    this.uw(i, e);
                }
                break;
            case 4:
                this.ss.clear();
                for (var j = 0; j < this.ck.count; j++) {
                    var k = new CalloutAnnotation();
                    var l = new CalloutAnnotationWrapper();
                    l.b = k;
                    l.b.series = this.rr;
                    this.ss.add(l);
                    this.uw(j, e);
                }
                break;
        }
        this.ml(true);
    };
    CalloutLayer.prototype.ep = function (a) {
        return false;
    };
    CalloutLayer.prototype.sn = function () {
        var a = new Dictionary$2(String_$type, Series.$, 0);
        if (this.cd != null) {
            for (var b = 0; b < this.cd.series.count; b++) {
                var c = this.cd.series._inner[b];
                if (c.name != null && !a.containsKey(c.name)) {
                    a.addItem(c.name, c);
                }
            }
        }
        return a;
    };
    CalloutLayer.prototype.uw = function (a, b) {
        var _this = this;
        if (this.r3 == null || this.r1 == null) {
            return;
        }
        var c = a;
        if (this.r2 != null) {
            c = this.r2.item(a);
        }
        var d = this.r3.item(a);
        var e = this.r1.item(a);
        var f = this.ss._inner[a];
        if (this.r0 != null) {
            if (f.b.ab != this.r0.item(a)) {
                f.b.key = this.r0.item(a);
            }
        }
        if (this.sm.containsKey(f)) {
            f.b = this.sm.item(f).c.b;
        }
        f.b.xValue = c;
        f.b.yValue = d;
        if (this.calloutLabelUpdating != null) {
            var g = ((function () {
                var $ret = new CalloutLabelUpdatingEventArgs();
                $ret.d = c;
                $ret.e = d;
                $ret.item = _this.ck.item(a);
                return $ret;
            })());
            this.calloutLabelUpdating(this, g);
            if (g.c != null && !Base.equalsStatic(g.c, f.b.ao)) {
                var h = g.c;
                f.b.text = h != null ? h.toString() : "";
            }
        }
        else {
            f.b.text = e != null ? e.toString() : "";
        }
        if (this.rz != null) {
            f.b.content = this.rz.item(a);
        }
        else {
            f.b.content = this.ck.item(a);
        }
        if (this.calloutSeriesSelecting != null) {
            var i = ((function () {
                var $ret = new CalloutSeriesSelectingEventArgs();
                $ret.c = c;
                $ret.d = d;
                $ret.item = _this.ck.item(a);
                return $ret;
            })());
            this.calloutSeriesSelecting(this, i);
            if (i.a != null) {
                f.b.series = i.a;
            }
            else if (i.e != null) {
                if (b.containsKey(i.e)) {
                    f.b.series = b.item(i.e);
                }
            }
        }
        this.ux(f);
    };
    CalloutLayer.prototype.ux = function (a) {
        var b = new Thickness(0, DeviceUtils.g(3));
        if (isNaN_(this.v0.left) || isNaN_(this.v0.top) || isNaN_(this.v0.right) || isNaN_(this.v0.bottom)) {
            b = new Thickness(0, DeviceUtils.g(3));
        }
        else {
            b = this.v0;
        }
        var c = DeviceUtils.g(3);
        if (isNaN_(this.sv)) {
            c = DeviceUtils.g(3);
        }
        else {
            c = this.sv;
        }
        var d = this.vt != null ? this.vt : this.rl.ci(a.b.l);
        var e = this.vw != null ? this.vw : this.rl.cl();
        var f = this.vv != null ? this.vv : this.rl.ck(a.b.l);
        var g = this.vu != null ? this.vu : this.rl.cj(a.b.l);
        var h = isNaN_(this.s1) ? 0 : this.s1;
        if (this.si && this.calloutStyleUpdating != null) {
            var i = new CalloutStyleUpdatingEventArgs();
            i.item = a.b.aa;
            i.xValue = a.b.ac;
            i.yValue = a.b.ad;
            i.series = a.b.l;
            i.background = d;
            i.textColor = e;
            i.outline = f;
            i.leaderBrush = g;
            i.strokeThickness = h;
            this.calloutStyleUpdating(this, i);
            d = i.background;
            e = i.textColor;
            f = i.outline;
            g = i.leaderBrush;
            h = i.strokeThickness;
        }
        a.b.backgroundPadding = b;
        a.b.backgroundCornerRadius = c;
        a.b.background = d;
        a.b.textColor = e;
        a.b.outline = f;
        a.b.leaderBrush = g;
        a.b.strokeThickness = h;
    };
    CalloutLayer.prototype.hy = function (a, b) {
        var c = this.js(b);
        if (c == CalloutLayer.$$p[21]) {
            return this.hz(a, b, this.t2);
        }
        if (c == CalloutLayer.$$p[28]) {
            return this.hz(a, b, this.ud);
        }
        if (c == CalloutLayer.$$p[29]) {
            return this.hz(a, b, this.ug);
        }
        if (c == CalloutLayer.$$p[20]) {
            return this.hz(a, b, this.tz);
        }
        if (c == CalloutLayer.$$p[15]) {
            return this.hz(a, b, this.ts);
        }
        return _super.prototype.hy.call(this, a, b);
    };
    Object.defineProperty(CalloutLayer.prototype, "r1", {
        get: function () {
            return this.rw;
        },
        set: function (a) {
            if (this.rw != a) {
                var b = this.rw;
                this.rw = a;
                this.raisePropertyChanged("LabelColumn", b, this.rw);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutLayer.prototype, "r2", {
        get: function () {
            return this.rx;
        },
        set: function (a) {
            if (this.rx != a) {
                var b = this.rx;
                this.rx = a;
                this.raisePropertyChanged("XColumn", b, this.rx);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutLayer.prototype, "r3", {
        get: function () {
            return this.ry;
        },
        set: function (a) {
            if (this.ry != a) {
                var b = this.ry;
                this.ry = a;
                this.raisePropertyChanged("YColumn", b, this.ry);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutLayer.prototype, "r0", {
        get: function () {
            return this.rv;
        },
        set: function (a) {
            if (this.rv != a) {
                var b = this.rv;
                this.rv = a;
                this.raisePropertyChanged("KeyColumn", b, this.rv);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutLayer.prototype, "rz", {
        get: function () {
            return this.ru;
        },
        set: function (a) {
            if (this.ru != a) {
                var b = this.ru;
                this.ru = a;
                this.raisePropertyChanged("ContentColumn", b, this.ru);
            }
        },
        enumerable: false,
        configurable: true
    });
    CalloutLayer.prototype.ul = function (a, b) {
        if (b.propertyName == CalloutAnnotation.$$p[14] || b.propertyName == CalloutAnnotation.$$p[15]) {
            var c = a.k;
            if (!this.so.contains(c)) {
                this.so.add_1(c);
                this.sr.add(c);
                this.ml(false);
            }
        }
    };
    CalloutLayer.prototype.bx = function () {
        return new CalloutLayerView(this);
    };
    CalloutLayer.prototype.l2 = function (a) {
        _super.prototype.l2.call(this, a);
        this.rl = a;
    };
    Object.defineProperty(CalloutLayer.prototype, "rn", {
        get: function () {
            return this.rm;
        },
        set: function (a) {
            var b = this.rn;
            if (a != b) {
                this.rm = a;
                this.raisePropertyChanged("AllowedPositions", b, this.rn);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutLayer.prototype, "rg", {
        get: function () {
            return EnumUtil.getEnumValue(AutoCalloutVisibilityMode_$type, this.c(CalloutLayer.vc));
        },
        set: function (a) {
            this.h(CalloutLayer.vc, enumGetBox(AutoCalloutVisibilityMode_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutLayer.prototype, "rf", {
        get: function () {
            return this.re;
        },
        set: function (a) {
            this.re = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutLayer.prototype, "v0", {
        get: function () {
            return new Thickness(1, this.sx, this.sz, this.sy, this.sw);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutLayer.prototype, "rt", {
        get: function () {
            if (this.rs == null) {
                this.rs = FontUtil.toFontInfo(this.hb, this.t7);
            }
            return this.rs;
        },
        enumerable: false,
        configurable: true
    });
    CalloutLayer.prototype.qt = function (a, b) {
        if (this.rr == null || this.rr == a) {
            if (!this.as.c) {
                this.ml(b);
            }
        }
    };
    CalloutLayer.prototype.qv = function (a, b) {
        var e_1, _a;
        _super.prototype.qv.call(this, a, b);
        var c = a;
        c.q.clear();
        c.r.clear();
        c.n.clear();
        c.f.clear();
        c.i.clear();
        c.h.clear();
        c.k.clear();
        c.m.clear();
        c.l.clear();
        c.j.clear();
        c.g.clear();
        c.o.clear();
        c.p.clear();
        c.u.clear();
        c.v.clear();
        c.s.clear();
        c.t.clear();
        var d = this.st();
        var e = new List$1(CalloutAnnotationWrapper.$, 0);
        var f = true;
        if (this.sf) {
            if (this.qg(this.rr)) {
                this.ut(this.rr, c, e);
            }
            else {
                try {
                    for (var _b = __values(fromEnum(this.cd.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var g = _c.value;
                        if (this.qg(g)) {
                            if (!g.dc) {
                                if (!g.isVertical) {
                                    f = false;
                                }
                            }
                            this.ut(g, c, e);
                        }
                    }
                }
                catch (e_1_1) {
                    e_1 = { error: e_1_1 };
                }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return))
                            _a.call(_b);
                    }
                    finally {
                        if (e_1)
                            throw e_1.error;
                    }
                }
            }
        }
        if (this.sf && this.rf == 2) {
            var h = 0;
            var i = 0;
            var j = 1.7976931348623157E+308;
            var k = 1.7976931348623157E+308;
            var l = -1.7976931348623157E+308;
            var m = -1.7976931348623157E+308;
            if (e.count > 0) {
                if (e._inner[0].c != null) {
                    h = e._inner[0].e;
                    i = e._inner[0].f;
                }
                for (var n = 0; n < e.count; n++) {
                    var o = e._inner[n];
                    if (o.c != null) {
                        var p = o.e;
                        var q = o.f;
                        if (p != h) {
                            j = Math.min(j, Math.abs(p - h));
                        }
                        if (q != i) {
                            k = Math.min(k, Math.abs(q - i));
                        }
                        l = Math.max(o.c.l + o.c.l, l);
                        m = Math.max(o.c.k + o.c.k, m);
                    }
                }
                if (f) {
                    if (m > k) {
                        e.clear();
                    }
                }
                else {
                    if (l > j) {
                        e.clear();
                    }
                }
            }
        }
        this.us(c, d, e);
    };
    CalloutLayer.prototype.m9 = function (a, b) {
        _super.prototype.m9.call(this, a, b);
        var c = b.width - this.vy.width;
        var d = b.height - this.vy.height;
        var e = 0;
        if (Math.abs(c) > Math.abs(d)) {
            e = c;
            this.su = c * this.p3.width;
        }
        else {
            e = d;
            this.su = d * this.p3.height;
        }
        if (e > 0 && this.su > 5) {
            this.se = true;
        }
        if (e < 0 && this.su > 5) {
            this.sd = true;
        }
    };
    CalloutLayer.prototype.m8 = function (a, b) {
        _super.prototype.m8.call(this, a, b);
        if (!a.equals1(b)) {
            this.sc = true;
        }
    };
    Object.defineProperty(CalloutLayer.prototype, "vz", {
        get: function () {
            return this.vx;
        },
        set: function (a) {
            this.vx = a;
        },
        enumerable: false,
        configurable: true
    });
    CalloutLayer.prototype.us = function (a, b, c) {
        var e_2, _a;
        if (this.cd != null) {
            this.vy = this.cd.s9;
        }
        if (this.p3.isEmpty) {
            return;
        }
        this.vz = new Rect(0, this.p3.left, this.p3.top, this.p3.width, this.p3.height);
        if (this.r4 != null && this.tp != null && this.tp != this.r4.ap) {
            this.un();
        }
        if (this.r4 == null) {
            var d = this.r5();
            if (d != null) {
                this.r4 = d;
                var e = this.r4;
                e.labelsMoved = delegateCombine(e.labelsMoved, runOn(this, this.uk));
            }
            else {
                var f = this.pv(this.b0);
                var g = new Array(2);
                g[0] = 0;
                g[1] = 3;
                if (this.rr != null) {
                    if (this.rr.isVertical) {
                        g = new Array(2);
                        g[0] = 2;
                        g[1] = 1;
                    }
                }
                else {
                    var h = false;
                    if (this.cd != null && this.cd.series.count > 0) {
                        h = true;
                        try {
                            for (var _b = __values(fromEnum(this.cd.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var i = _c.value;
                                if (!i.dc) {
                                    if (!i.isVertical) {
                                        h = false;
                                    }
                                }
                            }
                        }
                        catch (e_2_1) {
                            e_2 = { error: e_2_1 };
                        }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return))
                                    _a.call(_b);
                            }
                            finally {
                                if (e_2)
                                    throw e_2.error;
                            }
                        }
                    }
                    if (h) {
                        g = new Array(2);
                        g[0] = 2;
                        g[1] = 1;
                    }
                }
                this.r4 = new LabelCollisionManager(this.p3.right, this.p3.bottom, this.p3, this.rl.j(), this.s0, this.r6(), g, this.s7(), this.s6(), this.sg, this.rc);
                if (this.tp != null) {
                    this.r4.ap = this.tp;
                    this.r4.an = this;
                }
                var j = this.r4;
                j.labelsMoved = delegateCombine(j.labelsMoved, runOn(this, this.uk));
            }
        }
        if (this.sd) {
            this.sd = false;
            if (this.r4.al > 2) {
                this.sb = true;
            }
        }
        if (this.se) {
            this.se = false;
            if (this.su > 5) {
                this.sb = true;
            }
        }
        if (this.sc) {
            this.sc = false;
            this.r4.a3(this.p3.right, this.p3.bottom, this.p3);
            this.sb = true;
        }
        var k = new HashSet$1(CalloutAnnotationWrapper.$, 0);
        var l = new HashSet$1(CalloutAnnotationWrapper.$, 0);
        var m = new List$1(CalloutAnnotationWrapper.$, 0);
        var n = new List$1(CalloutAnnotationWrapper.$, 0);
        var o = new HashSet$1(CalloutAnnotationWrapper.$, 0);
        for (var p = 0; p < b.count; p++) {
            o.add_1(b._inner[p]);
        }
        for (var q = 0; q < c.count; q++) {
            o.add_1(c._inner[q]);
        }
        var r = this.sp.c;
        while (r != null) {
            var s = r.a;
            if (!o.contains(r.c)) {
                n.add(r.c);
                l.add_1(r.c);
                var t = r.c.b;
                t.propertyChanged = delegateRemove(t.propertyChanged, runOn(this, this.ul));
                this.sp.h(r);
                this.sm.removeItem(r.c);
                this.r4.a2(r.c.c);
            }
            r = s;
        }
        for (var u = 0; u < b.count; u++) {
            if (!this.sm.containsKey(b._inner[u])) {
                this.sp.f(b._inner[u]);
                var v = b._inner[u].b;
                v.propertyChanged = delegateCombine(v.propertyChanged, runOn(this, this.ul));
                this.sm.addItem(b._inner[u], this.sp.d);
                m.add(b._inner[u]);
                k.add_1(b._inner[u]);
                this.sb = true;
            }
        }
        for (var w = 0; w < c.count; w++) {
            if (!this.sm.containsKey(c._inner[w])) {
                this.sp.f(c._inner[w]);
                this.sm.addItem(c._inner[w], this.sp.d);
                var x = c._inner[w].b;
                x.propertyChanged = delegateCombine(x.propertyChanged, runOn(this, this.ul));
                m.add(c._inner[w]);
                k.add_1(c._inner[w]);
                this.sb = true;
            }
        }
        if (this.r9 == true) {
            this.r9 = false;
            this.sb = true;
        }
        if (this.sr.count > 0) {
            this.sb = true;
            this.sr.clear();
            this.so.clear();
        }
        r = this.sp.c;
        while (r != null) {
            var y = this.r7(r.c);
            if (y == null) {
                return;
            }
            if (!Base.equalsStatic(y, r.c.c.c)) {
                var z = false;
                if (r.c.c.c == null) {
                    z = true;
                }
                var aa = r.c.c;
                aa.o = y.b;
                aa.p = y.c;
                if (!isNaN_(aa.o) && !isNaN_(aa.p)) {
                    aa.n = y.e;
                    aa.m = y.d;
                    if (aa.b == null) {
                        this.r4.t(aa, false);
                    }
                    if (z) {
                        this.r4.aq(aa);
                    }
                    else {
                        this.r4.az(aa);
                    }
                }
            }
            r = r.a;
        }
        var ab = this.r4.am();
        var ac = this.r4.u();
        if (ac) {
            if (this.r4.q()) {
                this.sb = true;
            }
        }
        if (this.sb && (ab != 0 || ac)) {
            this.sb = false;
            this.s3 = 0x7FFFFFFF;
            if (this.tp != null) {
                var ad = true;
                for (var ae = 0; ae < this.cd.series.count; ae++) {
                    var af = this.cd.series._inner[ae];
                    if (af.dc && typeCast(CalloutLayer.$, af) !== null) {
                        var ag = af;
                        if (ag.tp == this.tp) {
                            if (!ag.vz.equals1(this.r4.a5)) {
                                ad = false;
                                break;
                            }
                        }
                    }
                }
                if (ad) {
                    this.r4.a4();
                }
                else {
                    this.r4.ar();
                    this.r4.as();
                }
            }
            else {
                this.r4.a4();
            }
        }
        else {
            this.r4.as();
        }
        var ah = this.sp.c;
        var ai;
        var aj;
        var ak;
        var al;
        var am;
        var an;
        var ao;
        var ap;
        var aq;
        var ar;
        var as;
        var at;
        var au;
        var av;
        var aw;
        var ax;
        var ay = this.sh;
        while (ah != null) {
            var az = ah.c;
            var a0 = az.b;
            ai = a0.bk;
            aj = a0.bm;
            ak = a0.bl;
            al = a0.backgroundPadding.left;
            am = a0.backgroundPadding.top;
            an = a0.backgroundPadding.right;
            ao = a0.backgroundPadding.bottom;
            aq = a0.backgroundCornerRadius;
            ap = a0.y;
            ar = a0.bn;
            as = a0.ao;
            at = a0.aa;
            var a1 = az.c;
            au = a1.o - (a1.g - a1.l);
            av = a1.p - (a1.h - a1.k);
            aw = a1.g - a1.l;
            ax = a1.h - a1.k;
            if (ay) {
                var a2 = new CalloutRenderStyleUpdatingEventArgs();
                a2.background = ai;
                a2.outline = aj;
                a2.leaderBrush = ak;
                a2.strokeThickness = ap;
                a2.textColor = ar;
                a2.item = at;
                a2.series = a0.l;
                a2.actualPosition = a1.a;
                a2.xValue = a0.ac;
                a2.yValue = a0.ad;
                if (this.calloutRenderStyleUpdating != null) {
                    this.calloutRenderStyleUpdating(this, a2);
                    ai = a2.background;
                    aj = a2.outline;
                    ak = a2.leaderBrush;
                    ap = a2.strokeThickness;
                    ar = a2.textColor;
                }
            }
            a.n.add1(az);
            a.f.add(ai);
            a.i.add(aj);
            a.h.add(ak);
            a.k.add(al);
            a.m.add(am);
            a.l.add(an);
            a.j.add(ao);
            a.g.add(aq);
            a.o.add(ap);
            a.p.add(ar);
            a.q.add1(as);
            a.r.add1(at);
            a.u.add(au);
            a.v.add(av);
            a.s.add(aw);
            a.t.add(ax);
            ah = ah.a;
        }
    };
    CalloutLayer.prototype.un = function () {
        if (this.r4 != null) {
            var a = this.sp.c;
            while (a != null) {
                var b = a.c.c;
                if (b != null) {
                    this.r4.a2(b);
                }
                a = a.a;
            }
            var c = this.r4;
            c.labelsMoved = delegateRemove(c.labelsMoved, runOn(this, this.uk));
            this.r4 = null;
        }
        this.um();
    };
    CalloutLayer.prototype.r5 = function () {
        if (this.cd == null) {
            return null;
        }
        for (var a = 0; a < this.cd.series.count; a++) {
            var b = this.cd.series._inner[a];
            if (b.dc && typeCast(CalloutLayer.$, b) !== null) {
                var c = b;
                if (c != this) {
                    if (c.tp != null && c.tp == this.tp) {
                        if (c.r4 != null) {
                            return c.r4;
                        }
                    }
                }
            }
        }
        return null;
    };
    CalloutLayer.prototype.s6 = function () {
        return 20000;
    };
    CalloutLayer.prototype.s7 = function () {
        return 300;
    };
    CalloutLayer.prototype.r6 = function () {
        switch (this.ri) {
            case 0: return 2;
            case 2: return 1;
            case 3: return 2;
            case 1: return 0;
        }
        return 2;
    };
    CalloutLayer.prototype.uk = function (a) {
        var b = this.r4.am();
        if (b < this.s3) {
            this.s3 = b;
            this.ml(false);
        }
    };
    CalloutLayer.prototype.r7 = function (a) {
        var b = this.rr;
        if (a.b.l != null) {
            b = a.b.l;
        }
        if (b == null) {
            for (var c = 0; c < this.cd.series.count; c++) {
                var d = this.cd.series._inner[c];
                if (!d.dc) {
                    b = d;
                    break;
                }
            }
        }
        if (b == null) {
            return null;
        }
        var e = b.ag();
        var f = b.ge();
        var g = null;
        var h = null;
        var i = false;
        for (var j = 0; j < e.length; j++) {
            if (e[j].b8) {
                i = true;
                g = e[j];
            }
            else if (e[j].cl) {
                i = true;
                h = e[j];
            }
            else if (e[j].co) {
                h = e[j];
            }
            else {
                g = e[j];
            }
        }
        if (g == null || h == null) {
            return null;
        }
        if (!g.cn() || !h.cn()) {
            return null;
        }
        var k = 0;
        var l = 0;
        if (g.ca && g.categoryMode != 0) {
            if (b.dq) {
                k = b.getOffsetValue();
            }
            else if (b.dh) {
                k = b.getOffsetValue();
            }
        }
        if (h.ca && h.categoryMode != 0) {
            if (b.dh) {
                l = b.getOffsetValue();
            }
        }
        var m = new ScalerParams(0, this.cd.s9, g.kc, g.cg, g.j7());
        m.b = f;
        var n = new ScalerParams(0, this.cd.s9, h.kc, h.cg, h.j7());
        n.b = f;
        var o = 0;
        var p = 0;
        if (i) {
            o = g.ei(this.s2(a.b.ac), m) + k;
            p = h.ei(this.s2(a.b.ad), n) + l;
            var q = o;
            var r = p;
            var s = { $type: Point_$type, x: 0.5, y: 0.5 };
            var t = s.x + (r * Math.cos(q));
            o = ViewportUtils.c(t, m.e, m.d);
            var u = s.y + (r * Math.sin(q));
            p = ViewportUtils.f(u, n.e, n.d);
        }
        else {
            o = g.ei(this.s2(a.b.ac), m) + k;
            p = h.ei(this.s2(a.b.ad), n) + l;
        }
        var v = new QuadTreeBoundingBox();
        v.b = o;
        v.c = p;
        v.e = 3;
        v.d = 3;
        v.g = a.b;
        return v;
    };
    CalloutLayer.prototype.s2 = function (a) {
        if (typeCast(Date_$type, a) !== null) {
            return a.getTime();
        }
        if (a == null) {
            return 0;
        }
        return a;
    };
    CalloutLayer.prototype.st = function () {
        var a = new List$1(CalloutAnnotationWrapper.$, 0);
        for (var b = 0; b < this.ss.count; b++) {
            if (stringIsNullOrEmpty(this.ss._inner[b].b.ao)) {
                continue;
            }
            if (this.ss._inner[b].c == null) {
                var c = new LabelCollisionInfo();
                this.ss._inner[b].c = c;
                var d = this.rl.cn(this.s8(this.ss._inner[b]), this.ss._inner[b].b.backgroundPadding);
                c.k = d.height / 2;
                c.l = d.width / 2;
            }
            var e = this.r7(this.ss._inner[b]);
            if (e == null || e.b < this.p3.left || e.b > this.p3.right || e.c < this.p3.top || e.c > this.p3.bottom) {
                continue;
            }
            a.add(this.ss._inner[b]);
        }
        return a;
    };
    CalloutLayer.prototype.s8 = function (a) {
        return a.b.ao;
    };
    CalloutLayer.prototype.qg = function (a) {
        if (!_super.prototype.qg.call(this, a)) {
            return false;
        }
        if (this.t4 != null) {
            if (a.dv) {
                var b = a.jr();
                if (!Base.equalsStatic(this.t4, b)) {
                    return false;
                }
            }
            else {
                if (!Base.equalsStatic(this.t4, a.name)) {
                    return false;
                }
            }
        }
        return true;
    };
    CalloutLayer.prototype.lv = function () {
        _super.prototype.lv.call(this);
        if (!this.as.c && !this.cv()) {
            return;
        }
        if (this.r8) {
            this.r8 = false;
            this.up();
        }
        if (this.cv()) {
            this.uv(this.qb, false);
        }
        else {
            this.uv(this.p9, false);
        }
    };
    CalloutLayer.prototype.uq = function () {
        if (!this.sa) {
            this.sa = true;
            this.ml(true);
        }
    };
    CalloutLayer.prototype.ut = function (a, b, c) {
        var d = false;
        if (this.sa) {
            this.sa = false;
            d = true;
        }
        if (!a.er && a.c1(this.sq, this.sl, this.sj, this.s4)) {
            var e = this.sq;
            var _loop_1 = function (f) {
                var g = e._inner[f];
                var h = g.a != null ? g.a.item : null;
                var i = g.a.item != null ? g.a.item : g.a;
                var j = a;
                var k = new CalloutKey(i, j);
                var l = new CalloutAnnotationWrapper();
                var m = new CalloutAnnotation();
                l.b = m;
                m.key = k;
                var n = false;
                if (this_1.sm.containsKey(l)) {
                    l = this_1.sm.item(l).c;
                    m = l.b;
                    n = d;
                }
                else {
                    n = true;
                }
                var o = m.ac;
                var p = m.ad;
                if (this_1.s2(o) != this_1.s2(g.b)) {
                    m.xValue = g.b;
                }
                if (this_1.s2(p) != this_1.s2(g.c)) {
                    m.yValue = g.c;
                }
                m.series = a;
                var q = false;
                if (g.d != m.ay) {
                    m.ay = g.d;
                    q = true;
                }
                if (n || q) {
                    if (this_1.calloutLabelUpdating != null) {
                        var r = ((function () {
                            var $ret = new CalloutLabelUpdatingEventArgs();
                            $ret.d = m.ac;
                            $ret.e = m.ad;
                            $ret.item = h;
                            $ret.a = a;
                            $ret.f = a.name;
                            return $ret;
                        })());
                        this_1.calloutLabelUpdating(this_1, r);
                        if (r.c != null && !Base.equalsStatic(r.c, l.b.ao)) {
                            var s = r.c;
                            l.b.text = s != null ? s.toString() : "";
                        }
                    }
                    else {
                        if (g.d != null) {
                            m.text = g.d;
                        }
                    }
                }
                if (m.ao == null) {
                    return "continue";
                }
                if (n || q) {
                    if (this_1.calloutContentUpdating != null) {
                        var t = ((function () {
                            var $ret = new CalloutContentUpdatingEventArgs();
                            $ret.c = m.ac;
                            $ret.d = m.ad;
                            $ret.item = h;
                            $ret.a = i;
                            return $ret;
                        })());
                        this_1.calloutContentUpdating(this_1, t);
                        if (t.a != null && t.a != l.b.aa) {
                            l.b.content = t.a;
                        }
                    }
                    else {
                        if (i != null && i != l.b.aa) {
                            l.b.content = i;
                        }
                    }
                }
                if (n) {
                    this_1.ux(l);
                }
                if (l.c == null) {
                    var u = new LabelCollisionInfo();
                    l.c = u;
                    var v = this_1.rl.cn(this_1.s8(l), l.b.backgroundPadding);
                    u.k = v.height / 2;
                    u.l = v.width / 2;
                }
                var w = this_1.r7(l);
                if (w == null || w.b < this_1.p3.left || w.b > this_1.p3.right || w.c < this_1.p3.top || w.c > this_1.p3.bottom) {
                    return "continue";
                }
                l.e = w.b;
                l.f = w.c;
                c.add(l);
            };
            var this_1 = this;
            for (var f = 0; f < this.sq.count; f++) {
                _loop_1(f);
            }
        }
    };
    CalloutLayer.prototype.bp = function () {
        return 1;
    };
    CalloutLayer.prototype.at = function (a, b) {
        var c = this.r4.f(a, b);
        if (c == null) {
            return null;
        }
        return c.u;
    };
    CalloutLayer.prototype.ex = function (a, b) {
        if (this.r4 == null) {
            return false;
        }
        return this.r4.f(a, b) != null;
    };
    CalloutLayer.prototype.uv = function (a, b) {
        var e_3, _a;
        var c = 0;
        var d = new HashSet$1(CalloutAnnotationWrapper.$, 0);
        for (c = 0; c < a.q.count; c++) {
            var e = a.n._inner[c];
            if (isNaN_(a.u._inner[c]) || isNaN_(a.v._inner[c])) {
                continue;
            }
            var f = this.rl.b8.item(e);
            d.add_1(e);
            if (f.h != a.q._inner[c]) {
                f.h = a.q._inner[c];
                var g = f.u();
            }
            f.e = a.o._inner[c];
            f.m = a.f._inner[c];
            f.p = a.p._inner[c];
            f.o = f.e > 0 ? a.i._inner[c] : this.b0.bq();
            f.n = a.h._inner[c];
            f.x = new Thickness(1, a.k._inner[c], a.m._inner[c], a.l._inner[c], a.j._inner[c]);
            f.d = a.g._inner[c];
            this.rl.cg(f, Math.min(a.s._inner[c], a.s._inner[c] + a.u._inner[c]), Math.min(a.t._inner[c], a.t._inner[c] + a.v._inner[c]));
            this.rl.ch(f, e, a.r._inner[c]);
            f.r = { $type: Point_$type, x: a.u._inner[c], y: a.v._inner[c] };
        }
        var h = new List$1(CalloutAnnotationWrapper.$, 0);
        try {
            for (var _b = __values(fromEnum(this.rl.b8.c)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var i = _c.value;
                if (!d.contains(i)) {
                    h.add(i);
                }
            }
        }
        catch (e_3_1) {
            e_3 = { error: e_3_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_3)
                    throw e_3.error;
            }
        }
        for (var j = 0; j < h.count; j++) {
            this.rl.b8.h(h._inner[j]);
        }
    };
    CalloutLayer.prototype.qy = function (a, b) {
        _super.prototype.qy.call(this, a, b);
        if (this.cv()) {
            this.uv(this.qb, true);
        }
        else {
            this.uv(this.p9, false);
        }
    };
    CalloutLayer.prototype.en = function () {
        return true;
    };
    CalloutLayer.prototype.l7 = function (a, b, c, d) {
        _super.prototype.l7.call(this, a, b, c, d);
        switch (b) {
            case CalloutLayer.$$p[24]:
                this.rs = null;
                this.rl.cf();
                this.ml(true);
                break;
            case CalloutLayer.$$p[22]:
            case CalloutLayer.$$p[23]:
                this.ml(true);
                break;
            case CalloutLayer.$$p[14]:
                this.ml(true);
                break;
            case "SeriesViewer":
                if (c != null) {
                    var e = c;
                    e.seriesAnimating = delegateRemove(e.seriesAnimating, runOn(this, this.uu));
                }
                if (d != null) {
                    var f = d;
                    f.seriesAnimating = delegateCombine(f.seriesAnimating, runOn(this, this.uu));
                }
                if (d == null) {
                    this.un();
                }
                break;
            case "AutoCalloutVisibilityMode":
                this.rf = this.rh();
                this.uo();
                break;
            case "AllowedPositions":
                if (c != null) {
                    var g = c;
                    g.collectionChanged = delegateRemove(g.collectionChanged, runOn(this, this.ui));
                }
                if (d != null) {
                    var h = d;
                    h.collectionChanged = delegateCombine(h.collectionChanged, runOn(this, this.ui));
                }
                this.rc = this.rd(this.rn);
                this.uo();
                break;
            case CalloutLayer.$$p[16]:
            case CalloutLayer.$$p[17]:
            case CalloutLayer.$$p[1]:
            case CalloutLayer.$$p[6]:
            case CalloutLayer.$$p[5]:
            case CalloutLayer.$$p[25]:
            case CalloutLayer.$$p[26]:
            case CalloutLayer.$$p[19]:
            case CalloutLayer.$$p[18]:
            case CalloutLayer.$$p[8]:
            case CalloutLayer.$$p[10]:
            case CalloutLayer.$$p[9]:
            case CalloutLayer.$$p[7]:
            case CalloutLayer.$$p[12]:
            case CalloutLayer.$$p[13]:
                this.uo();
                break;
            case CalloutLayer.$$p[21]:
                if (this.ck != null) {
                    this.ck.deregisterColumn(this.r1);
                    this.r1 = this.cj(this.t2);
                }
                break;
            case "LabelColumn":
                this.uo();
                break;
            case CalloutLayer.$$p[15]:
                if (this.ck != null) {
                    this.ck.deregisterColumn(this.rz);
                    this.rz = this.cj(this.ts);
                }
                break;
            case "ContentColumn":
                this.uo();
                break;
            case CalloutLayer.$$p[28]:
                if (this.ck != null) {
                    this.ck.deregisterColumn(this.r2);
                    this.r2 = stringIsNullOrEmpty(this.ud) == false ? this.cj(this.ud) : null;
                }
                break;
            case "XColumn":
                this.uo();
                break;
            case CalloutLayer.$$p[29]:
                if (this.ck != null) {
                    this.ck.deregisterColumn(this.r3);
                    this.r3 = this.cj(this.ug);
                }
                break;
            case "YColumn":
                this.uo();
                break;
            case CalloutLayer.$$p[20]:
                if (this.ck != null) {
                    this.ck.deregisterColumn(this.r0);
                    this.r0 = this.cj(this.tz);
                }
                break;
            case "KeyColumn":
                this.uo();
                break;
            case "FastItemsSource":
                this.r9 = true;
                if (typeCast(IFastItemsSource_$type, c) != null) {
                    c.deregisterColumn(this.r1);
                    c.deregisterColumn(this.rz);
                    c.deregisterColumn(this.r2);
                    c.deregisterColumn(this.r3);
                    c.deregisterColumn(this.r0);
                    this.r1 = null;
                    this.rz = null;
                    this.r2 = null;
                    this.r3 = null;
                    this.r0 = null;
                    this.ss.clear();
                }
                if (typeCast(IFastItemsSource_$type, d) != null) {
                    this.r1 = this.cj(this.t2);
                    this.rz = this.cj(this.ts);
                    if (stringIsNullOrEmpty(this.ud) == false) {
                        this.r2 = this.cj(this.ud);
                    }
                    this.r3 = this.cj(this.ug);
                    this.r0 = this.cj(this.tz);
                }
                this.uo();
                break;
        }
    };
    CalloutLayer.prototype.rh = function () {
        if (this.rg == 0) {
            return 1;
        }
        return this.rg;
    };
    CalloutLayer.prototype.rd = function (a) {
        if (a == null || a.count == 0) {
            return null;
        }
        var b = new Array(a.count);
        for (var c = 0; c < a.count; c++) {
            b[c] = a._inner[c];
        }
        return b;
    };
    CalloutLayer.prototype.uu = function (a) {
        if (a.dc) {
            return;
        }
        if ((a == this.rr || this.rr == null) && this.sf) {
            this.ml(false);
        }
    };
    CalloutLayer.prototype.uo = function () {
        if (this.r8 == false) {
            this.r8 = true;
            this.ml(false);
        }
    };
    CalloutLayer.prototype.um = function () {
        this.rl.b8.clear();
        this.sp.g();
        this.sm.clear();
    };
    CalloutLayer.prototype.up = function () {
        if (this.r3 == null || this.r1 == null) {
            var a = this.sp.c;
            while (a != null) {
                this.ux(a.c);
                a = a.a;
            }
            return;
        }
        var b = this.sn();
        for (var c = 0; c < this.r3.count; c++) {
            var d = void 0;
            if (this.ss.count <= c) {
                var e = new CalloutAnnotation();
                d = new CalloutAnnotationWrapper();
                d.b = e;
                d.b.series = this.rr;
                this.ss.add(d);
            }
            else {
                d = this.ss._inner[c];
            }
            this.uw(c, b);
        }
    };
    CalloutLayer.$t = markType(CalloutLayer, 'CalloutLayer', AnnotationLayer.$);
    CalloutLayer.vc = DependencyProperty.i("AutoCalloutVisibilityMode", AutoCalloutVisibilityMode_$type, CalloutLayer.$, new PropertyMetadata(2, enumGetBox(AutoCalloutVisibilityMode_$type, 0), function (a, b) { return a.raisePropertyChanged("AutoCalloutVisibilityMode", b.oldValue, b.newValue); }));
    CalloutLayer.$$p = markDep(DependencyProperty, PropertyMetadata, CalloutLayer, 'raisePropertyChanged', ['AutoCalloutLabelPrecision:s4:uy', [1, 5], 'CalloutBackground:vt:uz', [Brush.$, null], 'CalloutCollisionMode:ri:u0', [CalloutCollisionMode_$type, enumGetBox(CalloutCollisionMode_$type, 3)], 'CalloutCornerRadius:sv:u1', [1, NaN], 'CalloutInterpolatedValuePrecision:s5:u2', [1, -1], 'CalloutLeaderBrush:vu:u3', [Brush.$, null], 'CalloutOutline:vv:u4', [Brush.$, null], 'CalloutPaddingBottom:sw:u5', [1, NaN], 'CalloutPaddingLeft:sx:u6', [1, NaN], 'CalloutPaddingRight:sy:u7', [1, NaN], 'CalloutPaddingTop:sz:u8', [1, NaN], 'CalloutPositionPadding:s0:u9', [1, 10], 'CalloutStrokeThickness:s1:va', [1, NaN], 'CalloutTextColor:vw:vb', [Brush.$, null], 'CollisionChannel:tp:vd', [2, null], 'ContentMemberPath:ts:ve', [2, null], 'IsAutoCalloutBehaviorEnabled:sf:vf', [0, false], 'IsCalloutOffsettingEnabled:sg:vg', [0, true], 'IsCustomCalloutRenderStyleEnabled:sh:vh', [0, false], 'IsCustomCalloutStyleEnabled:si:vi', [0, false], 'KeyMemberPath:tz:vj', [2, null], 'LabelMemberPath:t2:vk', [2, null], 'TargetSeriesName:t4:vl', [2, null], 'TargetSeries:rr:vm', [Series.$, null], 'TextStyle:t7:vn', [2, null], 'UseInterpolatedValueForAutoCalloutLabels:sj:vo', [0, false], 'UseSeriesColorForOutline:sk:vp', [0, false], 'UseValueForAutoCalloutLabels:sl:vq', [0, true], 'XMemberPath:ud:vr', [2, null], 'YMemberPath:ug:vs', [2, null]]);
    return CalloutLayer;
}(AnnotationLayer));
export { CalloutLayer };
/**
 * @hidden
 */
var CalloutLayerView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(CalloutLayerView, _super);
    function CalloutLayerView(a) {
        var _this = _super.call(this, a) || this;
        _this.b4 = null;
        _this.b9 = null;
        _this.b8 = null;
        _this.ca = NaN;
        _this.b5 = null;
        _this.b4 = a;
        _this.b9 = new List$1(CalloutView.$, 0);
        return _this;
    }
    CalloutLayerView.prototype.as = function () {
        var _this = this;
        _super.prototype.as.call(this);
        this.b8 = ((function () {
            var $ret = new HashPool$2(CalloutAnnotationWrapper.$, CalloutView.$);
            $ret.create = runOn(_this, _this.b6);
            $ret.activate = runOn(_this, _this.cc);
            $ret.disactivate = runOn(_this, _this.ce);
            $ret.destroy = runOn(_this, _this.cd);
            return $ret;
        })());
    };
    CalloutLayerView.prototype.b6 = function () {
        var a = new CalloutView(this);
        this.b9.add(a);
        return a;
    };
    CalloutLayerView.prototype.cc = function (a) {
        a.y = 0;
    };
    CalloutLayerView.prototype.ce = function (a) {
        a.y = 1;
    };
    CalloutLayerView.prototype.cd = function (a) {
        this.b9.remove(a);
    };
    CalloutLayerView.prototype.cm = function (a) {
        if (a == null) {
            return a;
        }
        return BrushUtil.l(a, 0.1);
    };
    CalloutLayerView.prototype.a6 = function (a, b) {
        _super.prototype.a6.call(this, a, b);
        a.ad(this.b7());
        if (a.d && !b) {
            for (var c = 0; c < this.b9.count; c++) {
                var d = this.b9._inner[c];
                if (d.y == 0) {
                    d.j(a);
                }
            }
        }
    };
    CalloutLayerView.prototype.b7 = function () {
        if (this.b4.rt != null) {
            return this.b4.rt;
        }
        return this.e.cd.getFontInfo();
    };
    CalloutLayerView.prototype.al = function (a) {
        _super.prototype.al.call(this, a);
        for (var b = 0; b < this.b9.count; b++) {
            var c = this.b9._inner[b];
            if (c.y != 0) {
                continue;
            }
            c.i(this.b4, this.b7(), a);
        }
    };
    CalloutLayerView.prototype.co = function (a) {
        this.k.ad(this.b7());
        this.ca = this.cb();
        var b = this.k.ah(a, this.ca, true);
        return new Size(1, b.c, b.b);
    };
    CalloutLayerView.prototype.cb = function () {
        var a = this.b7();
        if (isNaN_(this.ca)) {
            var b = FontUtil.getCurrentFontHeight(this.e.cd.cu.j.ae, a);
            this.ca = b;
        }
        return this.ca;
    };
    CalloutLayerView.prototype.cn = function (a, b) {
        if (this.b5 == null) {
            this.b5 = new CalloutView(this);
        }
        this.b5.h = a;
        this.b5.x = b;
        var c = this.b5.u();
        this.b5.h = null;
        return c;
    };
    CalloutLayerView.prototype.cg = function (a, b, c) {
        a.f = b;
        a.g = c;
    };
    CalloutLayerView.prototype.ch = function (a, b, c) {
        a.k(this.e, b, c);
    };
    CalloutLayerView.prototype.ci = function (a) {
        if (a != null) {
            return this.cm(a.o8);
        }
        return this.e.o8;
    };
    CalloutLayerView.prototype.cl = function () {
        return ((function () {
            var $ret = new Brush();
            $ret.color = Color.u(255, 255, 255, 255);
            return $ret;
        })());
    };
    CalloutLayerView.prototype.ck = function (a) {
        if (this.b4.sk) {
            if (a != null) {
                return this.cm(a.o8);
            }
        }
        return ((function () {
            var $ret = new Brush();
            $ret.color = Color.u(255, 255, 255, 255);
            return $ret;
        })());
    };
    CalloutLayerView.prototype.cj = function (a) {
        if (a != null) {
            return this.cm(a.o3);
        }
        return this.e.o3;
    };
    CalloutLayerView.prototype.cf = function () {
        this.ca = NaN;
    };
    CalloutLayerView.$t = markType(CalloutLayerView, 'CalloutLayerView', AnnotationLayerView.$);
    return CalloutLayerView;
}(AnnotationLayerView));
export { CalloutLayerView };
/**
 * @hidden
 */
var CalloutView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(CalloutView, _super);
    function CalloutView(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.y = 0;
        _this.l = null;
        _this.t = null;
        _this.q = { $type: Point_$type, x: 0, y: 0 };
        _this.s = null;
        _this.w = new Thickness(0, 0);
        _this.v = null;
        _this.c = 0;
        _this.f = 0;
        _this.g = 0;
        _this.b = null;
        _this.s = new Line();
        _this.s.ab = false;
        _this.s._stroke = ((function () {
            var $ret = new Brush();
            $ret.color = Color.u(255, 0, 0, 0);
            return $ret;
        })());
        _this.s.ac = 2;
        _this.l = new TextBlock();
        _this.t = new Rectangle();
        _this.t.ac = 0;
        _this.a = a;
        _this.y = 0;
        return _this;
    }
    CalloutView.prototype.j = function (a) {
        a.aa();
        a.ag(this.f, this.g);
        var b = new TranslateTransform();
        b.j = this.v.left;
        b.k = this.v.top;
        this.t.j = b;
        a.s(this.s);
        a.aa();
        this.t.width = this.l.m + this.w.left + this.w.right;
        this.t.height = this.l.l + this.w.top + this.w.bottom;
        this.t.am = this.c;
        this.t.an = this.c;
        a.k(this.t.j);
        a.w(this.t);
        this.l.ag = true;
        this.l.o = this.w.top;
        this.l.n = this.w.left;
        a.x(this.l);
        a.z();
        a.z();
    };
    Object.defineProperty(CalloutView.prototype, "r", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            if (this.q.x != a.x || this.q.y != a.y) {
                var b = this.u();
                var c = b.height;
                var d = b.width;
                this.q = a;
                var e = CalloutViewHelper.b(this.r, d, c, this.s);
                this.v = e;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutView.prototype, "p", {
        get: function () {
            return this.l.ao;
        },
        set: function (a) {
            this.l.ao = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutView.prototype, "o", {
        get: function () {
            return this.t._stroke;
        },
        set: function (a) {
            this.t._stroke = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutView.prototype, "n", {
        get: function () {
            return this.s._stroke;
        },
        set: function (a) {
            this.s._stroke = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutView.prototype, "m", {
        get: function () {
            return this.t._fill;
        },
        set: function (a) {
            this.t._fill = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutView.prototype, "e", {
        get: function () {
            return this.t.ac;
        },
        set: function (a) {
            this.t.ac = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutView.prototype, "x", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            this.w = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutView.prototype, "d", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            this.c = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalloutView.prototype, "h", {
        get: function () {
            return this.l.al;
        },
        set: function (a) {
            if (a == null) {
                this.l.al = "";
            }
            else {
                this.l.al = a.toString();
            }
            var b = this.u();
            var c = b.height;
            var d = b.width;
            var e = CalloutViewHelper.b(this.r, d, c, this.s);
            this.v = e;
        },
        enumerable: false,
        configurable: true
    });
    CalloutView.prototype.u = function () {
        var a = this.a.co(this.l);
        this.l.m = a.width;
        this.l.l = a.height;
        return new Size(1, a.width + this.w.left + this.w.right, a.height + this.w.top + this.w.bottom);
    };
    CalloutView.prototype.k = function (a, b, c) {
        if (this.b == null) {
            this.b = new DataContext();
        }
        this.b.series = a;
        this.b.item = c;
        if (b.c != null) {
            b.c.u = this.b;
        }
    };
    CalloutView.prototype.i = function (a, b, c) {
        a.a8.exportCalloutData(this.f, this.g, this.v.left, this.v.top, c, this.t, this.l, b, this.s, "callout", ["Main", "Callout"]);
    };
    CalloutView.$t = markType(CalloutView, 'CalloutView');
    return CalloutView;
}(Base));
export { CalloutView };
